import { SwitchInput } from '@calendly/ui/components/switch-input'

import { SwitchWrapper } from './styles'

export const RecordingRulesSwitch = ({ value, onChange, setIsDirty = () => {}, disabled = false }) => (
  <SwitchWrapper>
    <SwitchInput
      role="switch"
      checked={value}
      onChange={() => {
        onChange(!value)
        setIsDirty(true)
      }}
      disabled={disabled}
    />
  </SwitchWrapper>
)
